<div>
  <span class="flex">
      <label class="{{labelClasses}} {{!readonly && required ? requiredClasses : ''}}" *ngIf="label"
             [ngClass]="{ disabled: isDisabled }">{{ label }}</label>
      <psc-info-icon [iconColorClass]="infoIconColorClass" [infoText]="infoText"
                     [sizeInPx]="infoIconSize"></psc-info-icon>
  </span>

  <psc-readonly-value
    *ngIf="readonly; else notReadonly"
    [value]="value">
  </psc-readonly-value>

  <ng-template #notReadonly>
    <div class="flex" *transloco="let t">
      <div
        class="inline-flex items-center px-3 border border-r-0 border-gray-300 rounded-l-md {{bgColorClass}} text-color-white font-bold min-w-fit"
        *ngIf="prefix || prefixIcon">
        {{prefix}}
        <i *ngIf="prefixIcon" class="pvsc-icon icon-{{prefixIcon}}"></i>
      </div>
      <input
        [ngClass]="{'rounded-l-none': prefix || prefixIcon, 'rounded-r-none': type === 'password' }"
        class="{{inputClasses}}"
        [name]="name"
        [type]="(type === 'password' && showPassword) ? 'text' : type"
        [ngModel]="value"
        (ngModelChange)="onModelChange($event)"
        placeholder="{{ placeholder || t('placeholders.text_input') }}"
        [disabled]="isDisabled"/>
      <div
        *ngIf="type === 'password'"
        (click)="showPassword = !showPassword"
        class="inline-flex items-center px-2 border border-l-0 border-gray-300 rounded-r-md {{bgColorClass}} text-color-white font-bold w-[42px] cursor-pointer">
        <mat-icon class="absolute" *ngIf="!showPassword" @popInOut>visibility</mat-icon>
        <mat-icon class="absolute" *ngIf="showPassword" @popInOut>visibility_off</mat-icon>
      </div>
    </div>
  </ng-template>

  <psc-input-error
    [control]="formControl"
    [format]="format"></psc-input-error>
</div>
